import Vue from "vue";
import Router from "vue-router";
import Landing from "@/components/Landing";
import Home from "@/components/Home";
import RetailAdminTools from "@/components/Retail-admin-tools";
import Profile from "@/components/Profile";
import MyAssociates from "@/components/MyAssociates";
import Metrics from "@/components/Metrics";
import Posts from "@/components/Posts";
import PaymentSection from "@/components/Payments";
import RetailRankList from "@/components/Retailer-rank-list";
import Referral from "@/components/Referral";
import AdminLogIn from "@/components/Admin-landing";
import JEET11 from "@/components/Jeet11";
import JEET11Distributor from "@/components/Jeet11Distributor";
import Invoice from "@/components/Invoice";
import FinanceAdminTools from "@/components/Finance-admin-tools";
import DistributorLogin from "@/components/DistributorLogin";
import UserStories from "@/components/UserStories";
import RechargeHistory from "@/components/RechargeHistory";
import RewardSection from "@/components/RewardSection";
import UserProfile from "@/components/RewardSection/UserProfile";
import store from "@/store";
import goTo from "vuetify/lib/components/Vuetify/goTo";
import RetailerUsers from "@/components/RetailerUsers";
import ManageDistributors from "@/components/ManageDistributors";
import TSMLandingPage from "@/components/TSM-landing";
import RBMLandingPage from "@/components/RBM-landing";
import FinanceDistributeRewards from "@/components/FinanceDistributeRewards";
import UserHistory from "@/components/UserHistory";
import DstrCommissionDashboard from "@/components/CommissionDashboard/DstrCommissionDashboard";
import RetailerCommissionDashboard from "@/components/CommissionDashboard/RetailerCommissionDashboard";
import Schemes from "@/components/Jeet11/schemes";
import CommissionPayout from "@/components/CommissionPayout";
// import PageUnderMaintenance from "@/components/PageUnderMaintenance";
import RummyDstr from "@/components/Rummy/RummyDstr";
import Rummy from "@/components/Rummy";
import RummyCommissionPayout from "@/components/Rummy/RummyCommissionPayout";
import RummyDistributorCommissionDashboard from "@/components/Rummy/RummyDistributorCommissionDashboard";
import RummyRetailerCommissionDashboard from "@/components/Rummy/RummyRetailerCommissionDashboard";
import UpdateSchemes from "@/components/Retail-admin-tools/Schemes";
import DstrSupportInvoice from "@/components/Retail-admin-tools/dstr-support-invoice";
import DstrSupportInvoiceFinance from "@/components/Finance-admin-tools/dstr-support-invoice";
import DstrGstInvoiceFinance from "@/components/Finance-admin-tools/dstr-gst-invoice";
import FinanceAdminReview from "@/components/Finance-admin-tools/Review";
import AgencyInvoiceNumbers from "@/components/AgencyInvoiceNumbers";
import QRCode from "@/components/QRCode";
import NotificationTool from "@/components/NotificationTool";
import AllLeaderboards from "@/components/AllLeaderboards";
import TaskReviewSection from "@/components/TaskReviewSection";
import LocationReview from "@/components/LocationReview";
import VisitHistory from "@/components/VisitHistory";
import WeekPlanning from "@/components/WeekPlanning";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: "/",
	linkActiveClass: "is-active",
	linkExactActiveClass: "is-exact-active",
	scrollBehavior: to => {
		let scrollTo = 0;

		if (to.hash) {
			scrollTo = to.hash;
		}

		return goTo(scrollTo);
	},
	routes: [
		{
			path: "/",
			name: "Landing",
			component: Landing,
			alias: ["/index"]
		},
		{
			path: "admin",
			name: "Admin",
			component: AdminLogIn,
			alias: ["/admin"]
		},
		{
			path: "distributor",
			name: "Distributor",
			component: DistributorLogin,
			alias: ["/distributor"]
		},
		{
			path: "/home",
			name: "Home",
			component: Home,
			meta: {
				requiresRetailAdminAccess: true,
				requiresRetailAccess: true,
				requiresFinanceAdminAccess: true
			},
			children: [
				{
					path: "review",
					name: "review",
					component: RetailAdminTools,
					alias: ["/review"],
					meta: {
						requiresRetailAdminAccess: true,
						requiresJEET11RBMAccess: true
					},
					props: {
						appType: "JEET11"
					}
				},
				{
					path: "profile",
					name: "profile",
					component: Profile,
					alias: ["/profile"],
					meta: {
						requiresRetailAccess: true,
						requiresJEET11DistributorAccess: true,
						requiresJEET11TSMAccess: true,
						requiresJEET11PartnerAccess: true,
						requiresJEET11CaptainAccess: true,
						requiresJEET11RBMAccess: true,
						requiresSomeAccess: true
					}
				},
				{
					path: "task-review-section",
					name: "task-review-section",
					component: TaskReviewSection,
					alias: ["/task-review-section"],
					meta: {
						requiresJEET11TSMAccess: true,
						requiresRetailAccess: true
					}
				},
				{
					path: "week-planning",
					name: "week-planning",
					component: WeekPlanning,
					alias: ["/week-planning"],
					meta: {
						requiresJEET11TSMAccess: true
					}
				},
				{
					path: "location-review",
					name: "location-review",
					component: LocationReview,
					alias: ["/location-review"],
					meta: {
						requiresJEET11RBMAccess: true
					}
				},
				{
					path: "visit-history",
					name: "visit-history",
					component: VisitHistory,
					alias: ["/visit-history"],
					meta: {
						requiresJEET11RBMAccess: true,
						requiresJEET11TSMAccess: true,
						requiresJEET11PartnerAccess: true,
						requiresRetailAccess: true
					}
				},
				{
					path: "associates",
					name: "associates",
					component: MyAssociates,
					alias: ["/my-associates"],
					meta: {
						requiresRetailAccess: true,
						requiresJEET11DistributorAccess: true,
						requiresJEET11TSMAccess: true,
						requiresJEET11PartnerAccess: true,
						requiresJEET11RBMAccess: true
					}
				},
				{
					path: "posts",
					name: "posts",
					component: Posts,
					alias: ["/posts"],
					meta: {
						requiresRetailAccess: true
					}
				},
				{
					path: "rank",
					name: "rank",
					component: RetailRankList,
					alias: ["/rank"],
					meta: {
						requiresRetailAccess: true,
						requiresRetailAdminAccess: true
					}
				},
				{
					path: "referral",
					name: "referral",
					component: Referral,
					alias: ["/referral"],
					meta: {
						requiresRetailAccess: true
					}
				},
				{
					path: "payment",
					name: "payment",
					component: PaymentSection,
					alias: ["/payment"],
					meta: {
						requiresRetailAccess: true
					}
				},
				{
					path: "jeet11",
					name: "jeet11",
					component: JEET11,
					alias: ["/jeet11"],
					meta: {
						requiresJEET11PartnerAccess: true,
						requiresJEET11PromoterAccess: true
					}
				},
				{
					path: "rummy",
					name: "rummy",
					component: Rummy,
					alias: ["/rummy"],
					meta: {
						requiresJEET11PartnerAccess: true,
						requiresJEET11PromoterAccess: true
					}
				},
				{
					path: "reward-section-rummy",
					name: "reward-section-rummy",
					component: RewardSection,
					alias: ["/reward-section-rummy"],
					meta: {
						requiresJEET11PartnerAccess: true
					},
					props: {
						appType: "RUMMY"
					}
				},
				{
					path: "rummy-dstr",
					name: "rummy-dstr",
					component: RummyDstr,
					alias: ["/rummy-dstr"],
					meta: {
						requiresJEET11DistributorAccess: true
					}
				},
				{
					path: "jeet11distributor",
					name: "jeet11distributor",
					component: JEET11Distributor,
					alias: ["/jeet11distributor"],
					meta: {
						requiresJEET11DistributorAccess: true
					}
				},
				{
					path: "invoice",
					name: "Invoice",
					component: Invoice,
					alias: ["/invoice"],
					meta: {
						requiresJEET11DistributorAccessOnly: true
					}
				},
				{
					path: "acknowledge",
					name: "acknowledge",
					component: FinanceAdminTools,
					alias: ["/acknowledge"],
					meta: {
						requiresFinanceAdminAccess: true
					}
				},
				{
					path: "user-stories",
					name: "user-stories",
					component: UserStories,
					alias: ["/user-stories"],
					meta: {
						requiresSomeAccess: true
					}
				},
				{
					path: "recharge-history",
					name: "recharge-history",
					component: RechargeHistory,
					alias: ["/recharge-history"],
					meta: {
						requiresJEET11PartnerAccess: true,
						requiresJEET11PromoterAccess: true
					}
				},
				{
					path: "reward-section",
					name: "reward-section",
					component: RewardSection,
					alias: ["/reward-section"],
					meta: {
						requiresJEET11PartnerAccess: true
					}
				},
				{
					path: "user-profile",
					name: "user-profile",
					component: UserProfile,
					alias: ["/user-profile"],
					meta: {
						requiresJEET11PartnerAccess: true
					}
				},
				{
					path: "retailer-users",
					name: "RetailerUsers",
					component: RetailerUsers,
					alias: ["/retailer-users"],
					meta: {
						requiresJEET11DistributorAccess: true
					}
				},
				{
					path: "manage-distributors",
					name: "ManageDistributors",
					component: ManageDistributors,
					alias: ["/manage-distributors"],
					meta: {
						requiresFinanceAdminAccess: true
					}
				},
				{
					path: "tsm",
					name: "tsm",
					component: TSMLandingPage,
					alias: ["/tsm"],
					meta: {
						requiresJEET11TSMAccess: true
					},
					props: {
						appType: "JEET11"
					}
				},
				{
					path: "rbm",
					name: "rbm",
					component: RBMLandingPage,
					alias: ["/rbm"],
					meta: {
						requiresJEET11RBMAccess: true
					},
					props: {
						appType: "JEET11"
					}
				},
				{
					path: "distribute-rewards",
					name: "FinanceDistributeRewards",
					component: FinanceDistributeRewards,
					alias: ["/distribute-rewards"],
					meta: {
						requiresFinanceAdminAccess: true
					}
				},
				{
					path: "user-history",
					name: "user-history",
					component: UserHistory,
					alias: ["/user-history"],
					meta: {
						requiresJEET11DistributorAccessOnly: true,
						requiresJEET11PartnerAccess: true,
						requiresJEET11PromoterAccess: true
					}
				},
				{
					path: "dstr-commission-dashboard",
					name: "dstr-commission-dashboard",
					component: DstrCommissionDashboard,
					alias: ["/dstr-commission-dashboard"],
					meta: {
						requiresJEET11DistributorAccessOnly: true
					}
				},
				{
					path: "dstr-commission-dashboard-rummy",
					name: "dstr-commission-dashboard-rummy",
					component: RummyDistributorCommissionDashboard,
					alias: ["/dstr-commission-dashboard-rummy"],
					meta: {
						requiresJEET11DistributorAccessOnly: true
					}
				},
				{
					path: "retailer-commission-dashboard",
					name: "retailer-commission-dashboard",
					component: RetailerCommissionDashboard,
					alias: ["/retailer-commission-dashboard"],
					meta: {
						requiresJEET11DistributorAccessOnly: true,
						requiresNewSchemeRetailAccess: true
					}
				},
				{
					path: "retailer-commission-dashboard-rummy",
					name: "retailer-commission-dashboard-rummy",
					component: RummyRetailerCommissionDashboard,
					alias: ["/retailer-commission-dashboard-rummy"],
					meta: {
						requiresJEET11DistributorAccessOnly: true,
						requiresNewSchemeRetailAccess: true
					}
				},
				{
					path: "schemes",
					name: "schemes",
					component: Schemes,
					alias: ["/schemes"],
					meta: {
						requiresJEET11PartnerAccess: true,
						requiresJEET11PromoterAccess: true,
						requiresJEET11DistributorAccess: true
					}
				},
				{
					path: "commission-payout",
					name: "commission-payout",
					component: CommissionPayout,
					alias: ["/commission-payout"],
					meta: {
						requiresNewSchemeDstrAccessFantasy: true
					}
				},
				{
					path: "commission-payout-rummy",
					name: "commission-payout-rummy",
					component: RummyCommissionPayout,
					alias: ["/commission-payout-rummy"],
					meta: {
						requiresNewSchemeDstrAccessCardGames: true
					}
				},
				{
					path: "update-schemes",
					name: "update-schemes",
					component: UpdateSchemes,
					alias: ["/update-schemes"],
					meta: {
						requiresRetailAdminAccess: true
					}
				},
				{
					path: "dstr-support-invoice",
					name: "dstr-support-invoice",
					component: DstrSupportInvoice,
					alias: ["/dstr-support-invoice"],
					meta: {
						requiresRetailAdminAccess: true
					}
				},
				{
					path: "dstr-support-invoice-finance",
					name: "dstr-support-invoice-finance",
					component: DstrSupportInvoiceFinance,
					alias: ["/dstr-support-invoice-finance"],
					meta: {
						requiresFinanceAdminAccess: true
					}
				},
				{
					path: "dstr-gst-invoice-finance",
					name: "dstr-gst-invoice-finance",
					component: DstrGstInvoiceFinance,
					alias: ["/dstr-gst-invoice-finance"],
					meta: {
						requiresFinanceAdminAccess: true
					}
				},
				{
					path: "review-finance",
					name: "review-finance",
					component: FinanceAdminReview,
					alias: ["/review-finance"],
					meta: {
						requiresFinanceAdminAccess: true
					}
				},
				{
					path: "invoice-numbers",
					name: "invoice-numbers",
					component: AgencyInvoiceNumbers,
					alias: ["/invoice-numbers"],
					meta: {
						requiresAgencyAccess: true
					}
				},
				{
					path: "metrics",
					name: "metrics",
					component: Metrics,
					alias: ["/metrics"],
					meta: {
						requiresRetailAccess: true,
						requiresJEET11DistributorAccess: true,
						requiresJEET11TSMAccess: true,
						requiresJEET11PartnerAccess: true,
						requiresJEET11RBMAccess: true
					}
				},
				{
					path: "qrCode",
					name: "qrCode",
					component: QRCode,
					alias: ["/qrCode"],
					meta: {
						requiresRetailAccess: true,
						requiresJEET11DistributorAccess: true,
						requiresJEET11TSMAccess: true,
						requiresJEET11PartnerAccess: true
					}
				},
				{
					path: "notifications",
					name: "notifications",
					component: NotificationTool,
					alias: ["/notifications"],
					meta: {
						requiresRetailAdminAccess: true,
						requiresFinanceAdminAccess: true
					}
				},
				{
					path: "leaderboards",
					name: "leaderboards",
					component: AllLeaderboards,
					alias: ["/all-leaderboards"],
					meta: {
						requiresJEET11PartnerAccess: true,
						requiresRetailAccess: true,
						requiresJEET11DistributorAccess: true,
						requiresJEET11TSMAccess: true
					}
				}
			]
		}
	]
});

router.beforeEach((to, from, next) => {
	const isRetailAdmin = store.getters["auth/isRetailAdmin"];
	const isRetailer = store.getters["auth/isRetailer"];
	const isJeet11Partner = store.getters["auth/isJeet11Partner"];
	const isJeet11Captain = store.getters["auth/isJeet11Captain"];
	const isJeet11TSM = store.getters["auth/isJeet11TSM"];
	const isJeet11RBM = store.getters["auth/isJeet11RBM"];
	const isJeet11Distributor = store.getters["auth/isJeet11Distributor"];
	const isJeet11Executive = store.getters["auth/isJeet11Executive"];
	const isFinanceAdmin = store.getters["auth/isFinanceAdmin"];
	const isJeet11Promoter = store.getters["auth/isJeet11Promoter"];
	const isAgency = store.getters["jeet11/isAgency"];
	const isMojAgency = store.getters["jeet11/isMojAgency"];
	const isOnlineUser = store.getters["auth/isOnlineUser"];
	const isNewSchemeRetailer = store.getters["jeet11/isNewSchemeRetailer"];
	const isNewSchemeRetailerCardGames =
		store.getters["jeet11/isNewSchemeRetailerCardGames"];
	const isInShopType = store.getters["jeet11/isInShopType"];

	if (to.meta.requiresOnlineUserAccess && isOnlineUser) {
		next();
	} else if (to.meta.requiresRetailAdminAccess && isRetailAdmin) {
		next();
	} else if (to.meta.requiresFinanceAdminAccess && isFinanceAdmin) {
		next();
	} else if (to.meta.requiresAgencyAccess && (isAgency || isMojAgency)) {
		next();
	} else if (
		(to.meta.requiresRetailAccess && isRetailer) ||
		to.name === "Admin" ||
		to.name === "Landing" ||
		to.name === "Distributor"
	) {
		next();
	} else if (
		to.meta.requiresJEET11DistributorAccessOnly &&
		isJeet11Distributor &&
		!isOnlineUser
	) {
		next();
	} else if (
		to.meta.requiresJEET11DistributorAccess &&
		(isJeet11Distributor || isJeet11Executive) &&
		!isOnlineUser
	) {
		next();
	} else if (
		to.meta.requiresJEET11PartnerAccess &&
		(isJeet11Partner || isJeet11Captain) &&
		!isOnlineUser
	) {
		next();
	} else if (to.meta.requiresJEET11PromoterAccess && isJeet11Promoter) {
		next();
	} else if (
		to.meta.requiresSomeAccess &&
		(isJeet11Distributor ||
			isJeet11Executive ||
			isJeet11Partner ||
			isJeet11Captain ||
			isRetailer ||
			isRetailAdmin) &&
		!isAgency &&
		!isMojAgency &&
		!isOnlineUser
	) {
		next();
	} else if (to.meta.requiresJEET11TSMAccess && isJeet11TSM) {
		next();
	} else if (to.meta.requiresJEET11RBMAccess && isJeet11RBM) {
		next();
	} else if (
		to.meta.requiresNewSchemeRetailAccess &&
		isNewSchemeRetailer &&
		(isJeet11Partner || (isJeet11Promoter && isInShopType))
	) {
		next();
	} else if (
		to.meta.requiresNewSchemeDstrAccessFantasy &&
		isJeet11Distributor &&
		isNewSchemeRetailer
	) {
		next();
	} else if (
		to.meta.requiresNewSchemeDstrAccessCardGames &&
		isJeet11Distributor &&
		isNewSchemeRetailerCardGames
	) {
		next();
	} else if (to.fullPath.includes("/process")) {
		const splitPath = to.fullPath.split("/process");
		const updatedPath = splitPath[0];
		const query = splitPath[1].split("?")[1];
		next(`${updatedPath}?${query}`);
	} else {
		next(from);
	}
});

export default router;
